import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

/* Pass icon prop from FAIcons.js file */

const FAIcon = ({ icon, size, spin, pulse, className, ...props }) => {
	return (
		<FontAwesomeIcon
			icon={icon}
			size={size}
			spin={spin}
			pulse={pulse}
			className={className}
			{...props}
		/>
	)
}

export default FAIcon
